import { Button } from "@coval/ui"
import { BotMessageSquare, LineChart } from "lucide-react"

import { EmptyFilteredState, EmptyStateCTA } from "@/components/EmptyStateCTA"
import { NewResourceButton } from "@/components/ResourceActionButton"

interface RunsTableEmptyStateProps {
  isRunsMode: boolean
  onSimulate?: () => void
  hasActiveFilters?: boolean
  resetLabel?: "Clear filters" | "Clear search"
  onResetFilters?: () => void
}

/** Empty-state CTA shown when the runs/simulations table has no rows. */
export function RunsTableEmptyState({
  isRunsMode,
  onSimulate,
  hasActiveFilters = false,
  resetLabel,
  onResetFilters,
}: RunsTableEmptyStateProps) {
  if (hasActiveFilters) {
    return (
      <EmptyFilteredState
        title={
          isRunsMode ? "No runs found" : "No simulated conversations found"
        }
        onReset={onResetFilters}
        resetLabel={resetLabel}
      />
    )
  }
  return (
    <EmptyStateCTA
      docsHref="https://docs.coval.ai/concepts/simulations/overview"
      icon={isRunsMode ? LineChart : BotMessageSquare}
      title={isRunsMode ? "No runs found" : "No simulated conversations found"}
      description={
        isRunsMode
          ? "Runs will appear here once you start evaluating your agents."
          : "Simulated conversations will appear here once you start running them."
      }
    >
      {onSimulate && (
        <NewResourceButton resourceName="Simulation" onClick={onSimulate} />
      )}
    </EmptyStateCTA>
  )
}

export function RunsTableQueryError({
  isFetching,
  onRetry,
}: {
  isFetching: boolean
  onRetry: () => void
}) {
  return (
    <div
      role="alert"
      className="shrink-0 p-4 text-sm"
      data-testid="runs-table-query-error"
    >
      <p>Couldn’t load the requested conversations. Try again.</p>
      <Button variant="secondary" disabled={isFetching} onClick={onRetry}>
        Try again
      </Button>
    </div>
  )
}
